var ImageStatus;
(function (ImageStatus) {
    ImageStatus[ImageStatus["success"] = 0] = "success";
    ImageStatus[ImageStatus["loading"] = 1] = "loading";
    ImageStatus[ImageStatus["fail"] = 2] = "fail";
    ImageStatus[ImageStatus["none"] = 3] = "none";
})(ImageStatus || (ImageStatus = {}));
export default ImageStatus;
